import { SvgIcon } from '@bob/library'
import { AppProviderContext } from '@websrc/App/AppContext'
import { CTA, ctaColorTheme } from '@websrc/App/Components/CTA'
import Heading from '@websrc/App/Components/Heading/Heading'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { CTAType } from '@websrc/DataMappers/mapCTA'
import { mapPageMessage } from '@websrc/DataMappers/mapSpot'
import React, { forwardRef, useContext } from 'react'

import { pageMessage } from './PageMessage.css'

interface Props {
  message: ReturnType<typeof mapPageMessage>
}

export const PageMessage = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { headline, level, size, description, ctas } = props.message
  const { matomoPageTemplate } = useContext(AppProviderContext)

  return (
    <div className={pageMessage._} ref={ref}>
      <Heading description={description} headline={headline} level={level} size={size} />
      <div className={pageMessage.ctaWrapper}>
        {ctas?.map((cta) => (
          <CTA
            className={cta?.type}
            colorTheme={ctaColorTheme(cta?.type)}
            cta={cta}
            fontWeight={'bold'}
            key={cta?.text}
            onClick={() => {
              matomo.trackEvent(
                'engagement',
                matomoPageTemplate,
                ['cta page message'],
                [cta?.text],
                'card'
              )
            }}
            prefix={
              cta?.icon && cta.type === CTAType.TERTIARY ? (
                <SvgIcon color={'blue6'} name={cta.icon} size={20} />
              ) : undefined
            }
            suffix={
              cta?.icon && cta.type != CTAType.TERTIARY ? (
                <SvgIcon
                  color={cta.type === 'primary' ? 'white' : 'blue6'}
                  name={cta.icon}
                  size={20}
                />
              ) : undefined
            }
            type={cta?.type}
          />
        ))}
      </div>
    </div>
  )
})
